/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BacktestEpisodeChartBarResponse } from './BacktestEpisodeChartBarResponse';
import type { BacktestEpisodeChartTradeResponse } from './BacktestEpisodeChartTradeResponse';
export type BacktestPositionEpisodeChartResponse = {
    run_id: string;
    episode_id: string;
    symbol: string;
    status: BacktestPositionEpisodeChartResponse.status;
    opened_trading_day: string;
    closed_trading_day: (string | null);
    effective_end_trading_day: string;
    run_start_trading_day: string;
    run_end_trading_day: string;
    holding_period_days: number;
    display_start_trading_day: string;
    display_end_trading_day: string;
    context_trading_days: number;
    has_more_before: boolean;
    has_more_after: boolean;
    dataset_key: string;
    data_version: string;
    trading_days: Array<string>;
    bars: Array<BacktestEpisodeChartBarResponse>;
    trades: Array<BacktestEpisodeChartTradeResponse>;
};
export namespace BacktestPositionEpisodeChartResponse {
    export enum status {
        OPEN = 'OPEN',
        CLOSED = 'CLOSED',
    }
}

